import { Button, Space, Typography } from 'antd';
import { translate } from 'libs';
import { ICheckableActionProps } from 'pages/setting/interfaces';
import React, { memo } from 'react';

const CheckableAction = ({
  selected,
  handleMove,
  handleHide,
  isLoading,
  disabledMove,
}: ICheckableActionProps) => {
  return (
    <Space className="checkable-action-container" size={10}>
      <Space className="selected-txt-block" size={4}>
        <Typography.Text className="txt-selected">
          {translate('settingPage.ogSetup.multiSelect.selected', { count: selected })}
        </Typography.Text>
      </Space>
      <Button
        className="btn-move"
        onClick={handleMove}
        loading={isLoading}
        disabled={!!disabledMove}
      >
        {translate('settingPage.ogSetup.moveOg')}
      </Button>
      <Button className="btn-hide" danger onClick={handleHide} loading={isLoading}>
        {translate('settingPage.ogSetup.hideOg')}
      </Button>
    </Space>
  );
};

export default memo(CheckableAction);
